import type { FC } from 'react';

import { FormInput } from '@catalyze/ui';

export const PasswordChange: FC = () => (
    <>
        <FormInput
            id="currentPassword"
            label="Current password"
            type="password"
        />

        <FormInput id="newPassword" label="New password" type="password" />
    </>
);
